import {buildTimestamp} from '@/helpers/dateUtils'
import {selectCountryCode} from '@/store/slices/countryCodeSlice'
import {getTimezoneByCountryCode} from '@/utils/constants/timeZones'
import {useSelector} from 'react-redux'

export const useTimePicker = (validationRules = []) => {
  const countryCode = useSelector(selectCountryCode)
  const timezone = getTimezoneByCountryCode(countryCode)

  const cleanValue = time => {
    if (!time || time.length === 0) return time

    const digitsOnly = time.replace(/:/g, '')

    if (digitsOnly.length >= 3) {
      return digitsOnly.slice(0, 2) + ':' + digitsOnly.slice(2, 4)
    }

    return digitsOnly
  }

  // end time should be greater than start time if they are on the same day
  const validateStartandEndTime = selectedTime => {
    if (!selectedTime) return ''

    const endTimeRule = validationRules.find(rule => rule.type === 'endTime')
    if (!endTimeRule) return ''

    if (endTimeRule.startTime && endTimeRule.startDate && endTimeRule.endDate) {
      const startTimestamp = buildTimestamp(endTimeRule.startDate, endTimeRule.startTime, timezone)
      const endTimestamp = buildTimestamp(endTimeRule.endDate, selectedTime, timezone)

      if (endTimestamp <= startTimestamp) {
        return 'Active end time must be after start time'
      }
    }
    return ''
  }

  return {
    validateStartandEndTime,
    cleanValue,
  }
}
